/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-04 15:14:38
 *
 *******************************************************/
// @flow
/* eslint jsx-a11y/anchor-is-valid: 0 */
/* eslint no-script-url: 0 */

import _ from 'lodash';
import React, { Component } from 'react';
import validateColor from 'validate-color';

import productImage1 from 'src/assets/images/product/default-theme-settings/Cutout Cami Dress/Army Green/Army-Green_1.jpg';
import productImage1_hover from 'src/assets/images/product/default-theme-settings/Cutout Cami Dress/Army Green/Army-Green_2.jpg';
import productImage1a from 'src/assets/images/product/default-theme-settings/Cutout Cami Dress/Black/Black_1.jpg';
import productImage1a_hover from 'src/assets/images/product/default-theme-settings/Cutout Cami Dress/Black/Black_2.jpg';
import productImage1b from 'src/assets/images/product/default-theme-settings/Cutout Cami Dress/Brown/Brown_1.jpg';
import productImage1b_hover from 'src/assets/images/product/default-theme-settings/Cutout Cami Dress/Brown/Brown_2.jpg';
import productImage1c from 'src/assets/images/product/default-theme-settings/Cutout Cami Dress/Burnt Orange/Burnt-Orange_1.jpg';
import productImage1c_hover from 'src/assets/images/product/default-theme-settings/Cutout Cami Dress/Burnt Orange/Burnt-Orange_2.jpg';
import productImage2 from 'src/assets/images/product/default-theme-settings/Ruffle Flare Dress/Black/Black_1.jpg';
import productImage2_hover from 'src/assets/images/product/default-theme-settings/Ruffle Flare Dress/Black/Black_2.jpg';
import productImage2a from 'src/assets/images/product/default-theme-settings/Ruffle Flare Dress/Brown/Brown_1.jpg';
import productImage2a_hover from 'src/assets/images/product/default-theme-settings/Ruffle Flare Dress/Brown/Brown_2.jpg';
import productImage2b from 'src/assets/images/product/default-theme-settings/Ruffle Flare Dress/Maroon/Maroon_1.jpg';
import productImage2b_hover from 'src/assets/images/product/default-theme-settings/Ruffle Flare Dress/Maroon/Maroon_2.jpg';

const ImageDisplay = [
  [productImage1, productImage1a, productImage1b, productImage1c],
  [productImage2, productImage2a, productImage2b]
];
const ImageHover = [
  [productImage1_hover, productImage1a_hover, productImage1b_hover, productImage1c_hover],
  [productImage2_hover, productImage2a_hover, productImage2b_hover]
];
type Props = {
  settings: Object,
  filterData: Object
};

type State = {
  currentImage: Array<number>,
  productTitleStyle: Object,
  productVendorStyle: Object,
  productPriceStyle: Object,
  productDescriptionStyle: Object,
  productLabelStyle: Object
};

class PreviewProduct extends Component<Props, State> {
  state = {
    currentImage: [0, 0],
    productTitleStyle: {},
    productVendorStyle: {},
    productPriceStyle: {},
    productDescriptionStyle: {},
    productLabelStyle: {}
  };

  componentDidMount() {
    const { settings = {} } = this.props;

    // Render preview content
    this.renderPreview(settings);
  }

  componentWillReceiveProps(nextProps: Props) {
    const { settings = {} } = nextProps;

    // Render preview content
    this.renderPreview(settings);
  }

  renderPreview = (settings: Object) => {
    // Need improve performance: check only changed props
    const { products = {} } = settings;
    let {
      // Details
      productTitleColor,
      productTitleFont,
      productTitleSize,
      productTitleTransform,
      productVendorColor,
      productVendorFont,
      productVendorSize,
      productVendorTransform,
      productPriceColor,
      productOldPriceColor,
      productSalePriceColor,
      productPriceFont,
      productPriceSize,
      // Label
      saleLabelBg,
      saleLabelText,
      saleLabelDisplay = [],
      soldOutBg,
      soldOutText,
      soldOutDisplay = [],
      tagLabelBg,
      tagLabelText
    } = products;

    if (_.isEmpty(settings)) return;

    try {
      const productTitleStyle = {
        color: productTitleColor,
        fontFamily: productTitleFont,
        fontSize: `${productTitleSize}px`,
        textTransform: productTitleTransform
      };

      const productVendorStyle = {
        color: productVendorColor,
        fontFamily: productVendorFont,
        fontSize: `${productVendorSize}px`,
        textTransform: productVendorTransform
      };

      const productPriceStyle = {
        price: {
          color: productPriceColor,
          fontFamily: productPriceFont,
          fontSize: `${productPriceSize}px`
        },
        oldPrice: {
          color: productOldPriceColor
        },
        salePrice: {
          color: productSalePriceColor
        }
      };
      const productDescriptionStyle = {};

      const productLabelStyle = {
        general: {},
        sale:
          saleLabelDisplay[0] === 'image'
            ? { color: 'transparent', backgroundColor: 'transparent', borderColor: 'transparent' }
            : {
                color: saleLabelText,
                backgroundColor: saleLabelBg,
                borderColor: '#d2d8db'
              },
        soldOut:
          soldOutDisplay[0] === 'image'
            ? { color: 'transparent', backgroundColor: 'transparent', borderColor: 'transparent' }
            : {
                color: soldOutDisplay[0] === 'image' ? 'transparent' : soldOutText,
                backgroundColor: soldOutDisplay[0] === 'image' ? 'transparent' : soldOutBg,
                borderColor: soldOutDisplay[0] === 'image' ? 'transparent' : '#d2d8db'
              },
        tag: {
          color: tagLabelText,
          backgroundColor: tagLabelBg
        }
      };

      this.setState({
        productTitleStyle,
        productVendorStyle,
        productPriceStyle,
        productDescriptionStyle,
        productLabelStyle
      });
    } catch (error) {
      console.log('Error: Render preview', error);
    }
  };

  render() {
    const {
      settings: { products = {}, general = {} }
    } = this.props;
    const { layoutType = ['box'] } = general;
    let {
      productItemType,
      productItemLayout = 'no-border',
      textAlignment = 'left',
      showVendor,
      showPrice,
      showProductReview,
      showDetailWhenHover,
      activeImageSwap,
      productImgCrop,

      swatchEnable,
      showSwatchTooltip,
      swatchByColorApply = [],
      swatchByColorShape = 'circle',
      swatchByImgApply = [],
      swatchByImgShape = 'circle',
      swatchByProImgApply = [],
      swatchByProImgShape = 'circle',
      swatchByTextApply = [],
      swatchByTextShape = 'square',

      labelType,
      labelPosition = 'top_left',
      saleLabelEnable,
      saleLabelDisplay = [],
      saleLabelImg = {},
      soldOutEnable,
      soldOutDisplay = [],
      soldOutImg = {},
      tagLabelEnable
    } = products;

    const {
      currentImage,
      productTitleStyle,
      productVendorStyle,
      productPriceStyle,
      productLabelStyle
    } = this.state;

    let layoutClass = 'boost-pfs-container-default-box';
    if (layoutType[0] === 'fullwidth') {
      layoutClass = 'boost-pfs-container-default-fullwidth';
    }

    // Wrapper class for product items
    let wrapperClass =
      'boost-pfs-filter-products boost-pfs-filter-product-item-label-has-border boost-pfs-filter-product-item-equal-height-auto';
    wrapperClass += ` boost-pfs-filter-product-item-label-type-${
      labelType === 'circle' ? 'circle' : 'rectangle'
    }`;
    wrapperClass += ` boost-pfs-filter-product-item-show-details-${
      showDetailWhenHover ? 'true' : 'false'
    }`;
    wrapperClass += showSwatchTooltip ? ' boost-pfs-filter-product-item-show-swatch-tooltip' : '';
    wrapperClass += ` boost-pfs-filter-product-item-layout-${productItemLayout}`;
    wrapperClass += ` boost-pfs-filter-product-item-label-${labelPosition}`;
    wrapperClass += ` boost-pfs-filter-product-item-text-alignment-${textAlignment}`;

    // Class for product item
    let productClass = `boost-pfs-filter-product-item`;
    productClass += ` boost-pfs-filter-product-item-${productItemType}`;
    productClass +=
      productItemType === 'grid'
        ? ' boost-pfs-filter-grid-width-2 boost-pfs-filter-grid-width-mb-2'
        : '';
    productClass += ' on-sale boost-pfs-action-list-enabled';
    productClass += activeImageSwap ? ' has-bc-swap-image' : '';

    // Sale label display
    const saleLabelType = saleLabelDisplay[0];
    const saleLabelContent =
      saleLabelType === 'sale_percent' ? (
        '25%'
      ) : saleLabelType === 'image' ? (
        <img
          src={
            _.isObject(saleLabelImg)
              ? ['image/png', 'image/jpeg'].includes(saleLabelImg.type)
                ? window.URL.createObjectURL(saleLabelImg)
                : ''
              : saleLabelImg
          }
          alt=""
          style={{ maxWidth: '73px', maxHeight: '73px' }}></img>
      ) : (
        'Sale'
      );

    // Sold out label display
    const soldOutType = soldOutDisplay[0];
    const soldOutContent =
      soldOutType === 'image' ? (
        <img
          src={
            _.isObject(soldOutImg)
              ? ['image/png', 'image/jpeg'].includes(soldOutImg.type)
                ? window.URL.createObjectURL(soldOutImg)
                : ''
              : soldOutImg
          }
          alt=""
          style={{ maxWidth: '73px', maxHeight: '73px' }}></img>
      ) : (
        'Sold out'
      );

    const paddingImage = this.calculateRatio();

    return (
      <div>
        <div className={layoutClass}>
          <div className={`${wrapperClass} bc-al-style4`}>
            <div className={productClass}>
              <div className="boost-pfs-filter-product-item-inner">
                <div className="boost-pfs-filter-product-item-image">
                  <a
                    href="#"
                    className={`boost-pfs-filter-product-item-image-link boost-pfs-filter-crop-image-position-${productImgCrop} boost-pfs-action-overlay`}
                    style={{ paddingTop: `${paddingImage}` }}>
                    <img
                      className=" boost-pfs-filter-product-item-main-image"
                      src={ImageDisplay[0][currentImage[0]]}
                      alt="Cutout Cami Dress"
                    />
                    <img
                      className="boost-pfs-filter-product-item-flip-image"
                      src={ImageHover[0][currentImage[0]]}
                      alt="Cutout Cami Dress"
                    />
                  </a>
                  <div
                    className="boost-pfs-filter-product-item-label"
                    style={productLabelStyle.general}>
                    {saleLabelEnable && (
                      <span className="sale boost-pfs-filter-label" style={productLabelStyle.sale}>
                        {saleLabelContent}
                      </span>
                    )}
                    {soldOutEnable && (
                      <span
                        className="soldout boost-pfs-filter-label"
                        style={productLabelStyle.soldOut}>
                        {soldOutContent}
                      </span>
                    )}
                    {tagLabelEnable && (
                      <span className="tag boost-pfs-filter-label" style={productLabelStyle.tag}>
                        Tag
                      </span>
                    )}
                  </div>
                </div>
                <div className="boost-pfs-filter-product-bottom">
                  <a
                    href="#"
                    className="boost-pfs-filter-product-item-title"
                    style={productTitleStyle}>
                    Cutout Cami Dress
                  </a>
                  {showProductReview && (
                    <span className="spr-badge">
                      <span className="spr-starrating spr-badge-starrating">
                        <i className="spr-icon spr-icon-star"></i>
                        <i className="spr-icon spr-icon-star"></i>
                        <i className="spr-icon spr-icon-star"></i>
                        <i className="spr-icon spr-icon-star"></i>
                        <i className="spr-icon spr-icon-star-empty"></i>
                      </span>
                      <span className="spr-badge-caption">2 reviews</span>
                    </span>
                  )}

                  {showVendor && (
                    <p className="boost-pfs-filter-product-item-vendor" style={productVendorStyle}>
                      Vendor
                    </p>
                  )}
                  {showPrice && (
                    <p
                      className="boost-pfs-filter-product-item-price"
                      style={productPriceStyle.price}>
                      <span
                        className="boost-pfs-filter-product-item-sale-price"
                        style={productPriceStyle.salePrice}>
                        $144.39
                      </span>
                      <s style={productPriceStyle.oldPrice}>$199.39</s>
                    </p>
                  )}

                  {/* Render swatch */}
                  {/* Swatch by color */}
                  {swatchEnable && (
                    <React.Fragment>
                      {this.renderSwatch(0, 'color', {
                        shape: swatchByColorShape[0],
                        options: swatchByColorApply
                      })}
                      {/* Swatch by color image */}
                      {this.renderSwatch(0, 'colorImage', {
                        shape: swatchByImgShape[0],
                        options: swatchByImgApply
                      })}
                      {/* Swatch by product image */}
                      {this.renderSwatch(0, 'productImage', {
                        shape: swatchByProImgShape[0],
                        options: swatchByProImgApply
                      })}
                      {/* Swatch by text */}
                      {this.renderSwatch(0, 'text', {
                        shape: swatchByTextShape[0],
                        options: swatchByTextApply
                      })}
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
            <div className={productClass}>
              <div className="boost-pfs-filter-product-item-inner">
                <div className="boost-pfs-filter-product-item-image">
                  <a
                    href="#"
                    className={`boost-pfs-filter-product-item-image-link boost-pfs-filter-crop-image-position-${productImgCrop} boost-pfs-action-overlay`}
                    style={{ paddingTop: `${paddingImage}` }}>
                    <img
                      className="boost-pfs-filter-product-item-main-image"
                      src={ImageDisplay[1][currentImage[1]]}
                      alt="Ruffle Flare Dress"
                    />
                    <img
                      className="boost-pfs-filter-product-item-flip-image"
                      src={ImageHover[1][currentImage[1]]}
                      alt="Ruffle Flare Dress"
                    />
                  </a>
                </div>
                <div className="boost-pfs-filter-product-bottom">
                  <a
                    href="#"
                    className="boost-pfs-filter-product-item-title"
                    style={productTitleStyle}>
                    Ruffle Flare Dress
                  </a>
                  {showProductReview && (
                    <span className="spr-badge" data-rating="4.0">
                      <span className="spr-starrating spr-badge-starrating">
                        <i className="spr-icon spr-icon-star"></i>
                        <i className="spr-icon spr-icon-star"></i>
                        <i className="spr-icon spr-icon-star"></i>
                        <i className="spr-icon spr-icon-star"></i>
                        <i className="spr-icon spr-icon-star-empty"></i>
                      </span>
                      <span className="spr-badge-caption">23 reviews</span>
                    </span>
                  )}
                  {showVendor && (
                    <p className="boost-pfs-filter-product-item-vendor" style={productVendorStyle}>
                      Vendor
                    </p>
                  )}
                  {showPrice && (
                    <p
                      className="boost-pfs-filter-product-item-price"
                      style={productPriceStyle.price}>
                      <span className="boost-pfs-filter-product-item-regular-price">$99.49</span>
                    </p>
                  )}

                  {/* Render swatch */}
                  {/* Swatch by color */}
                  {swatchEnable && (
                    <React.Fragment>
                      {this.renderSwatch(1, 'color', {
                        shape: swatchByColorShape[0],
                        options: swatchByColorApply
                      })}
                      {/* Swatch by color image */}
                      {this.renderSwatch(1, 'colorImage', {
                        shape: swatchByImgShape[0],
                        options: swatchByImgApply
                      })}
                      {/* Swatch by product image */}
                      {this.renderSwatch(1, 'productImage', {
                        shape: swatchByProImgShape[0],
                        options: swatchByProImgApply
                      })}
                      {/* Swatch by text */}
                      {this.renderSwatch(1, 'text', {
                        shape: swatchByTextShape[0],
                        options: swatchByTextApply
                      })}
                    </React.Fragment>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderSwatch = (index: number, type: string, config: Object) => {
    const {
      filterData,
      settings: { products = {} }
    } = this.props;
    const {
      swatchChangeImg = ['none'],
      swatchByTextBg,
      swatchByTextColor,
      swatchByTextBorder
    } = products;
    const swatchChangeImgAction = swatchChangeImg[0];
    const { shape = 'circle', options = [] } = config;
    if (!options || !_.isArray(options) || (_.isArray(options) && !options.length)) {
      return;
    }

    // Get options values
    const optionName = _.get(options, `[0].value`, '');
    const optionList = _.get(filterData, optionName, []);
    const sliced = _.isArray(optionList) ? optionList.slice(0, index === 1 ? 3 : 4) : [];

    // Random colors if the color value is invalid
    const randomColors = ['#01295a', '#c5c5c5', '#b9a124', '#7b10c7'];
    const gradientColors = [
      'linear-gradient(45deg, rgba(34,193,195,1) 0%, rgba(253,187,45,1) 100%)',
      'linear-gradient(45deg, rgba(2,0,36,1) 0%, rgba(0,212,255,1) 100%)',
      'linear-gradient(45deg, rgba(63,94,251,1) 0%, rgba(252,70,107,1) 100%',
      'linear-gradient(45deg, rgba(131,58,180,1) 0%, rgba(253,29,29,1) 100%'
    ];

    const borderRadius = shape === 'square' ? '0px' : '15px';

    // Swatch by Color, Color Image and Product Image
    if (['color', 'colorImage', 'productImage'].includes(type)) {
      return (
        <ul className="boost-pfs-filter-item-swatch boost-pfs-filter-item-swatch-color">
          {sliced.map((option, optionIndex) => {
            const { label } = option;

            return (
              <li
                key={`preview-option-${type}-${label}`}
                onMouseOver={() =>
                  swatchChangeImgAction === 'hover' && this.updateImage(index, optionIndex)
                }
                onClick={() =>
                  swatchChangeImgAction === 'click' && this.updateImage(index, optionIndex)
                }>
                <div className="boost-pfs-product-item-tooltip">{label}</div>
                <span
                  style={
                    type === 'productImage'
                      ? {
                          backgroundImage: `url(${ImageDisplay[index][optionIndex]})`,
                          borderRadius
                        }
                      : type === 'colorImage'
                      ? {
                          backgroundImage: gradientColors[optionIndex],
                          borderRadius
                        }
                      : {
                          backgroundColor: validateColor(label) ? label : randomColors[optionIndex],
                          borderRadius
                        }
                  }></span>
              </li>
            );
          })}
        </ul>
      );
    }

    // Swatch by Text
    if (type === 'text') {
      return (
        <ul className="boost-pfs-filter-item-swatch boost-pfs-filter-item-swatch-size">
          {sliced.map((option, optionIndex) => {
            const { label } = option;
            return (
              <li
                style={{
                  borderRadius,
                  backgroundColor: swatchByTextBg,
                  borderColor: swatchByTextBorder
                }}
                key={`preview-option-${type}-${label}`}
                onMouseOver={() =>
                  swatchChangeImgAction === 'hover' && this.updateImage(index, optionIndex)
                }
                onClick={() =>
                  swatchChangeImgAction === 'click' && this.updateImage(index, optionIndex)
                }>
                <a title={label} href="#" style={{ color: swatchByTextColor }}>
                  {label}
                </a>
              </li>
            );
          })}
        </ul>
      );
    }
  };

  updateImage = (index: number, value: number) => {
    const { currentImage } = this.state;
    currentImage[index] = value;
    this.setState({ currentImage });
  };

  calculateRatio = () => {
    const {
      settings: { products = {} }
    } = this.props;

    const { aspectRatio = 'auto', aspectRatioOther = '' } = products;
    let result = '132%';
    switch (aspectRatio) {
      case 'auto': {
        break;
      }
      case '1:1': {
        result = '100%';
        break;
      }
      case '2:3': {
        result = '150%';
        break;
      }
      case '4:3': {
        result = '75%';
        break;
      }
      case 'other': {
        const splitRatio = aspectRatioOther.toString().split(':');
        const w = parseInt(splitRatio[0]);
        const h = parseInt(splitRatio[1]);
        if (!(isNaN(w) || isNaN(h) || w === 0)) {
          result = `${(h / w) * 100}%`;
        }
        break;
      }
      default: {
        result = '132%';
      }
    }
    return result;
  };
}

export default PreviewProduct;
